import { render, staticRenderFns } from "./ChangeEmail.vue?vue&type=template&id=0f94cd13&scoped=true&"
import script from "./ChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ChangeEmail.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEmail.vue?vue&type=style&index=0&id=0f94cd13&prod&lang=css&"
import style1 from "./ChangeEmail.vue?vue&type=style&index=1&id=0f94cd13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f94cd13",
  null
  
)

export default component.exports